<template>
  <div style="width: 100%; height: 72px;margin-bottom: 20px;">
    <div
      ref="bgc"
      style="display: flex; justify-content: center; width: 100%; height: 72px"
      class="noBgc"
    >
      <div :class="path == '/' ? 'w' : 'now'">
        <div style="margin-right: 34px" class="logoImg"></div>

        <div :class="path == '/' ? 'navBox active' : 'navBox'" @click="navGet('1')">
          网站首页
        </div>
        <div :class="path == '/lsitFs' ? 'navBox active' : 'navBox'" @click="navGet('2')">
          继续教育
        </div>
        <div :class="path == '/zyjy' ? 'navBox active' : 'navBox'" @click="navGet('9')">
          职业教育
        </div>
        <div :class="path == '/resourcesList' ? 'navBox active' : 'navBox'" @click="navGet('10')">
          课程资源库
        </div>
        <div :class="path == '/car' ? 'navBox active' : 'navBox'" @click="navGet(3)">
          购物车
        </div>
        <div :class="path == '/studyMain' ? 'navBox active' : 'navBox'" @click="navGet(7)">
          学习中心
        </div>
        <div :class="path == '/wzgn' ? 'navBox active' : 'navBox'" @click="navGet(4)">
          帮助中心
        </div>
        <div :class="path == '/tzgg' ? 'navBox active' : 'navBox'" @click="navGet(5)">
          新闻资讯
        </div>
        <div :class="path == '/zscy' ? 'navBox active' : 'navBox'" @click="navGet(6)">
          证书查验
        </div>

     
        <div class="nologinBox">
          <div class="nameBox" @click="goStudy">  {{ this.$store.state.m_user.userInfo.realname || ''}}</div>
          <span style="margin: 0 10px; padding-bottom: 2px" class="su">|</span>
          <span @click="logout" class="noLogis">退出登录</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { getUser, getUrl, logout } from '../../api/index';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: ['value'],
   metaInfo: {
    title: '安徽省继续教育网'
  },
  data() {
    // 这里存放数据
    return {
      iconSHow: false,
      indexShow: 1,
      logo: '',
      url: '',
      list: [],
      path: '',
      className: '',
      userName: '', //用户名称
      localValue: '0702',
      fp: '',
      userInfo: {},
      pcCenterUrl: '',
      mobileCenterUrl: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {
    // localValue: {
    //   get() {
    //     return this.value; // 返回父组件传递的值
    //   }
    // }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    logout() {
      this.$confirm('确定要退出登录吗?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          logout({}).then(res => {
            this.$message({
              type: 'success',
              message: '退出登录成功!'
            });
            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            if (isMobile) {
              window.location.replace(this.$store.state.m_user.mobileCenterUrl);
            } else {
              window.location.replace(this.$store.state.m_user.pcCenterUrl);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    getUser() {
      getUser().then(res => {
        console.log(res);
        this.userInfo = res.data.data;
      });
    },
    goStudy() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        window.location.replace(this.$store.state.m_user.mobileCenterUrl + '?token=' + localStorage.getItem('token'));
      } else {
        window.location.replace(this.$store.state.m_user.pcCenterUrl + '?token=' + localStorage.getItem('token'));
      }
    },
    getUrl() {
      getUrl().then(res => {
        console.log(res.data.data);
        this.mobileCenterUrl = res.data.data.mobileCenterUrl;
        this.pcCenterUrl = res.data.data.pcCenterUrl;
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile) {
          localStorage.setItem('url', this.mobileCenterUrl);
        } else {
          localStorage.setItem('url', this.pcCenterUrl);
        }
      });
    },
    navGet(id) {
      this.indexShow = id;
      if (id == 1) {
        window.location.replace('https://www.ahsjxjy.com/'+'?token='+ localStorage.getItem('token'));
      } else if (id == 2) {
        window.location.replace('https://www.ahsjxjy.com/lsitFs'+'?token='+ localStorage.getItem('token'));
      } else if (id == 9) {
        window.location.replace('https://www.ahsjxjy.com/zyjy'+'?token='+ localStorage.getItem('token'));
      } else if (id == 3) {
        window.location.replace('https://www.ahsjxjy.com/car'+'?token='+ localStorage.getItem('token'));
      } else if (id == 4) {
        window.location.replace('https://www.ahsjxjy.com/wzgn'+'?token='+ localStorage.getItem('token'));
      } else if (id == 5) {
        window.location.replace('https://www.ahsjxjy.com/tzgg'+'?token='+ localStorage.getItem('token'));
      } else if (id == 6) {
        window.location.replace('https://www.ahsjxjy.com/zscy'+'?token='+ localStorage.getItem('token'));
      } else if (id == 7) {
        window.location.replace('https://www.ahsjxjy.com/studyMain'+'?token='+ localStorage.getItem('token'));
      } else if (id == 8) {
        window.location.replace('https://www.ahsjxjy.com/studyMain1'+'?token='+ localStorage.getItem('token'));
      } else if (id == '10') {
        window.location.replace('https://www.ahsjxjy.com/resourcesList'+'?token='+ localStorage.getItem('token'));
      }
    },
    destroyed() {
      localStorage.removeItem('userName1');
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query.className) {
      this.className = this.$route.query.className;
    }
    this.path = this.$route.path;
    console.log(this.path);
    if (this.path == '/') {
      this.iconSHow = true;
    } else {
      this.iconSHow = false;
    }
    this.userName = localStorage.getItem('userName1');
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    setTimeout(() => {
      this.url = this.$store.state.m_user.url;
      this.list = this.$store.state.m_user.list;
    }, 300);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */

.nologinBox {
  margin-left: 90px;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  display: flex;
  .nameBox{
    width: 70px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.now {
  position: relative;
  width: 1400px;
  height: 72px;
  display: flex;
  align-items: center;
  .logoImg {
    width: 200px;
    height: 42px;
    background: url('../../assets/indexImg/logo1@2x.png') no-repeat;
    background-size: cover;
  }
  .navBox {
    width: 100px;
    text-align: center;
    height: 71px;
    line-height: 71px;
    margin-right: 4px;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
    position: relative;
  }
  .loginBox {
    margin-left: 137px;
    width: 109px;
    height: 36px;
    border-radius: 18px 18px 18px 18px;
    border: 1px solid #ffffff;
    line-height: 36px;
    font-size: 14px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }
}
.w {
 
  width: 1400px;
  height: 72px;
  display: flex;
  align-items: center;
  .logoImg {
    width: 200px;
    height: 42px;
    background: url('../../assets/indexImg/logo1@2x.png') no-repeat;
    background-size: cover;
  }
  .navBox {
    width: 100px;
    text-align: center;
    height: 71px;
    line-height: 71px;
    margin-right: 4px;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
    position: relative;
    .bor {
      opacity: 0;
      position: absolute;
      bottom: 0;
      width: 60px;
      height: 3px;
      background: linear-gradient(90deg, #6996ff 0%, #4076f6 100%);
      border-radius: 4px 4px 0px 0px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .loginBox {
    margin-left: 137px;
    width: 109px;
    height: 36px;
    border-radius: 18px 18px 18px 18px;
    border: 1px solid #ffffff;
    line-height: 36px;
    font-size: 14px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }
}
.noBgc {
  position: fixed;
  top: 0;
  z-index: 9;
  background: #fff !important;
  cursor: pointer;
  .logoImg {
    width: 200px !important;
    height: 42px !important;
    background: url('../../assets/indexImg/logo2@2x.png') no-repeat !important;
    background-size: cover !important;
  }
  .navBox {
    font-size: 16px;
    color: #222222 !important;
    cursor: pointer;
    position: relative;
    .bor {
      opacity: 0;
      position: absolute;
      bottom: 0;
      width: 60px;
      height: 3px;
      background: linear-gradient(90deg, #6996ff 0%, #4076f6 100%);
      border-radius: 4px 4px 0px 0px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .loginBox {
    border: 1px solid #dadada !important;
    color: #999999 !important;
    cursor: pointer;
  }
  .nologinBox {
    margin-left: 70px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    text-align: center;
    color: #4076f6 !important;
    cursor: pointer;
    display: flex;
    align-items: center;
    .nameBox{
    max-width: 83px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  }
  .noLogis {
    color: #666;
  }
  .su {
    color: #666;
  }
  .navBox:hover {
    color: #4076f6 !important;
    cursor: pointer;
    .bor {
      opacity: 1 !important;
    }
  }
  .active {
 
  }
  .loginBox:hover {
    background: linear-gradient(103deg, #6996ff 0%, #4076f6 100%) !important;
    color: #fff !important;
    border: 0 !important;
  }
}
.bagc{
  background: #fff;
  cursor: pointer;
  .logoImg {
    width: 200px !important;
    height: 42px !important;
    background: url('../../assets/indexImg/logo2@2x.png') no-repeat !important;
    background-size: cover !important;
  }
  .navBox {
    font-size: 16px;
    color: #222222 !important;
    cursor: pointer;
    position: relative;
    .bor {
      opacity: 0;
      position: absolute;
      bottom: 0;
      width: 60px;
      height: 3px;
      background: linear-gradient(90deg, #6996ff 0%, #4076f6 100%);
      border-radius: 4px 4px 0px 0px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .loginBox {
    border: 1px solid #dadada !important;
    color: #999999 !important;
    cursor: pointer;
  }
  .nologinBox {
    display: flex;
    margin-left: 90px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    text-align: center;
    color: #4076f6 !important;
    cursor: pointer;
  }
  .navBox:hover {
    color: #4076f6 !important;
    cursor: pointer;
    .bor {
      opacity: 1 !important;
    }
  }
  .active {
 
  }
  .loginBox:hover {
    background: linear-gradient(103deg, #6996ff 0%, #4076f6 100%) !important;
    color: #fff !important;
    border: 0 !important;
  }
}
</style>
